import { defaultApiState } from '@/store/types/general.types';
import { CourseState, CourseTabsNames } from './course.types';

export const courseState: CourseState = {
  apiState: {
    getCourseCountForEachStatus: defaultApiState,
    getCourseTypes: defaultApiState,
    getCourses: defaultApiState,
    getCourseDetails: defaultApiState,
    getDefaultCourseLevelAttributes: defaultApiState,
    getRequiredPublicCourseLevelAttributes: defaultApiState,
    createNewCourse: defaultApiState,
    createDraftCourse: defaultApiState,
    updateCourse: defaultApiState,
    updateCourseType: defaultApiState,
    getCourseBySlug: defaultApiState,
    getFullCourseDetailsBySlug: defaultApiState
  },
  courseCountForEachStatus: undefined,
  courseTypes: undefined,
  courses: undefined,
  courseBySlug: undefined,
  courseDetails: undefined,
  defaultCourseLevelAttributes: undefined,
  requiredPublicCourseLevelAttributes: [],
  createdDraftCourseId: undefined,
  createdCourseId: undefined,
  courseLevelAttributeState: {
    locationGLAConfig: [],
    listOfContacts: []
  },
  courseCreationState: {
    hasModules: false,
    hasPackages: false,
    selectedCourseType: undefined,
    courseSize: undefined,
    courseStartDate: undefined,
    courseEndDate: undefined,
    isFreeCourse: undefined,
    hasQuestionnaire: undefined
  },
  courseTabState: {
    activeTabName: CourseTabsNames.ATTRIBUTES
  },
  courseLicenseState: {
    shouldCreateWithLicense: false
  },
  publicCourseState: {
    courseDetails: undefined
  }
};
